module.exports = __webpack_public_path__ + "img/pIndex-t-slide2.2abcbb97.jpg";